export default "__VITE_ASSET__LklgNwLt__"